import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import { CreateFolderInput, CreateFolderMutation } from '@/gql/graphql';

const CREATE_FOLDER_MUTATION = graphql(`
  mutation CreateFolder($input: CreateFolderInput!) {
    createFolder(input: $input) {
      id
      name
      parentId
      isRoot
    }
  }
`);

const useCreateFolder = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    CreateFolderMutation,
    unknown,
    CreateFolderInput
  >;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(CREATE_FOLDER_MUTATION, { input });
    },
    onSuccess: () => {
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.folders(args.projectId),
        });
      }
    },
    ...args?.options,
  });
};

export default useCreateFolder;
